<div class="kProgressBar">
  <div #bar class="kProgress"></div>
</div>
